import { StoreKey } from '@plugins/middleware-api';

import {
  AdminStoreOperation,
  BaseStoreOperation,
  StorePermissionLevel,
  UserRoleScope,
} from '../types';

export const STORE_PERMISSION_LEVELS: Record<
  StoreKey['type'],
  StorePermissionLevel
> = {
  tenant: { read: 1, write: 3, readSecret: 5, writeSecret: 5 },
  editor: { read: 1, write: 2, readSecret: 4, writeSecret: 4 },
  user: { read: 1, write: 1, readSecret: 4, writeSecret: 4 },
};

export const ROLE_SCOPE_LEVEL: Record<UserRoleScope, number> = {
  tenant: 5,
  editor: 4,
};

export const ADMIN_STORE_OPERATION: Record<
  BaseStoreOperation,
  AdminStoreOperation
> = {
  read: 'readSecret',
  write: 'writeSecret',
};
